import { motion } from "framer-motion";
import { STR } from "@/data/i18n";
import { useLang } from "@/lib/lang";

export const Preloader = () => {
    const { lang } = useLang();
    return (
        <motion.div
            data-testid="preloader"
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505]"
            exit={{ opacity: 0, scale: 1.05 }}
            transition={{ duration: 0.65, ease: "easeInOut" }}
        >
            <motion.img
                src="/assets/techflaze-logo.webp"
                alt="TechFlaze"
                className="h-16 w-auto md:h-24"
                initial={{ opacity: 0, scale: 0.85, filter: "drop-shadow(0 0 0px rgba(245,158,11,0))" }}
                animate={{
                    opacity: 1,
                    scale: 1,
                    filter: "drop-shadow(0 0 45px rgba(245,158,11,0.85))",
                }}
                transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            />
            <motion.div
                className="mt-10 h-px w-44 origin-left bg-gradient-to-r from-red-600 via-orange-500 to-amber-400"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
                aria-hidden="true"
            />
            <motion.p
                className="mt-5 text-[11px] font-semibold uppercase tracking-[0.35em] text-zinc-500"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.6 }}
            >
                {STR.misc[lang].igniting}
            </motion.p>
        </motion.div>
    );
};
